import { Datalayer } from "../../layers/datalayer";
import { DatalayerZone } from "../../layers/datalayerZone";
import { IDataLayerZone, ZoneTextLocation } from "../../layers/types";
import { INutrientAppZone } from "../types";
import { NutrientAppZone } from "./nutrientAppZone";

export class NutrientAppLayer extends Datalayer {

    protected createZoneInstance(zone: IDataLayerZone): DatalayerZone {

        return new NutrientAppZone(this, <INutrientAppZone>zone);

    }

    getZoneText(zone: DatalayerZone, location: ZoneTextLocation): string {
        const v = this.viewer
        return v?.getZoneText(zone, location)
    }

}

